import contentfulGql from 'js/lib/contentfulGql';

export const ImageFragment = contentfulGql`#graphql
  fragment Image on Asset {
    width
    height
    url
    title
    description
    contentType
  }
`;

export const VideoFragment = contentfulGql`#graphql
  fragment Video on Asset {
    sys {
      id
      spaceId
      environmentId
    }
    url
    title
    description
    contentType
  }
`;

const PartnerFragment = contentfulGql`#graphql
  ${ImageFragment}

  fragment Partner on PromoTemplatePartner {
    sys {
      id
    }
    name
    logo {
      ...Image
    }
    description
    target
  }
`;

export const CareerAcademyArticlesCollectionFragment = contentfulGql`#graphql
  fragment CareerAcademyArticlesCollection on PromoTemplateArticlesCollection {
      heading
      description
      backgroundColor
      articleCollectionSetsCollection(limit: 24) {
        items {
          sys {
            id
          }
          filter
          articlesCollection(limit: 24) {
            items {
              sys {
                id
              }
              title
              description
              date
              slug
            }
          }
        }
      }
    }
`;

const CareerAcademyTestimonialFragment = contentfulGql`#graphql
  ${ImageFragment}
  ${VideoFragment}
  ${PartnerFragment}

  fragment CareerAcademyTestimonial on PromoTemplateTestimonial {
    sys {
      id
    }
    author
    authorTitle
    authorOrganization {
      ...Partner
    }
    associatedProduct
    image {
      ...Image
    }
    video {
      ...Video
    }
    testimonial
  }
`;

export const CareerAcademyTestimonialCarouselFragment = contentfulGql`#graphql
  ${CareerAcademyTestimonialFragment}
  
  fragment CareerAcademyTestimonialCarousel on PromoTemplateTestimonialCarousel {
    sys {
      id
    }
    headline
    displayStyle
    backgroundColor
    testimonialsCollection {
      items {
        ...CareerAcademyTestimonial
      }
    }
  }
`;

export const CareerAcademyHeroFragment = contentfulGql`#graphql
  ${ImageFragment}
  ${VideoFragment}

  fragment CareerAcademyHero on PromoTemplateHero {
    sys {
      id
    }
    eyebrow
    eyebrowBackground
    eyebrowImage {
      ...Image
    }
    headline
    description

    image {
      ...Image
    }

    video {
      ...Video
    }

    ctaText
    ctaTarget
    secondaryCtaText
    secondaryCtaTarget
    secondaryCtaVariant

    layout
    backgroundColor
    backgroundImage {
      ...Image
    }
    height
    showBottomBorder
  }
`;
